import axios from "axios";
// initial state
const state = {
  user: JSON.parse(localStorage.getItem("user")),
  country: '',
  company: null,
};

// getters
const getters = {
  getUser: state => state.user,
  getCompanyInfo: state => state.company,
  getCountry: state => state.country,
};

// actions
const actions = {
  UserGetInfo({ commit }) {
    return axios({
        url: "/home",
        method: "GET"
      })
      .then(res => {
        commit("setUser", res.data.payload);
        localStorage.setItem("user", JSON.stringify(res.data.payload));
        return res.data.payload;
      });
  },
  UserPatchInfo({ rootState }, user) {
    return new Promise(resolve => {
      axios({
        url: rootState.api + "/home",
        data: user,
        method: "PATCH"
      }).then(() => {
        resolve();
      });
    });
  },
  UserGetCountry({ commit }, id) {
    return new Promise(resolve => {
      axios({
        url: "/country/" + id,
        method: "GET"
      }).then(res => {
        commit("setCountry", res.data.payload.nice_name);
        // localStorage.setItem("user", JSON.stringify(res.data.payload));
        resolve(res.data.payload);
      });
    });
  },
  // UserGetCompanyInfo({ commit }, companyId) {
  //   return new Promise(resolve => {
  //     axios({
  //       url: "/user/list",
  //       params: { 
  //         company_uuid: companyId,
  //       },
  //       method: "GET"
  //     }).then(res => {
  //       res.data.payload.items.map((i) => {
  //         console.log('companyId---->',companyId)
  //         console.log('i.company.company_uuid--->',i.company.company_uuid)
  //         if(i.company.company_uuid == companyId){
  //           console.log('i----------->', i)
  //           commit("setCompany", i.company);
  //         }
  //       })
       
  //       resolve(res.data.payload);
  //     });
  //   });
  // },
};

// mutations
const mutations = {
  setUser: (state, user) => {
    state.user = user;
  },
  setCountry(state, value) {
    state.country = value;
  },
  setCompany: (state, value) => {
    state.company = value;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
